import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useBusinessPurposeChartStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    ...shorthands.gap(tokens.spacingVerticalM),
    position: 'relative',
  },
});
